import Advice from "components/common/Advice";

const ComplianceAndGovernanceAdvice = () => {
  return (
    <Advice
      showQuote
      paragraph={
        "Somos uma empresa responsável, que atua em prol de uma sociedade inclusiva e sustentável. Estamos comprometidos com a ética, seguindo leis e regulamentações que garantem a justiça, a segurança e o bem-estar social. Com integridade, lideramos pelo exemplo e inspiramos confiança em cada relação. Assim, caminhamos firmes e conscientes de que esse é o caminho para construir reputações sólidas e transformar mercados”."
      }
      authorName={"Sany Silveira"}
      authorProfessionalPosition={"Diretora Presidente da CNP Seguros Holding Brasil"}
    />
  );
};

export default ComplianceAndGovernanceAdvice;
